module.exports = {
	"config": {
		"black": "#111111",
		"blackest": "#000000",
		"white": "#ffffff",
		"url": "https://example.com",
		"name": "",
		"legal_name": "",
		"logo": "",
		"email": "",
		"phone_number": "",
		"address_city": "",
		"address_state": "",
		"address_zipcode": "",
		"address_street": "",
		"address_area": "",
		"twitter": "",
		"twitter_id": "",
		"default_title": "",
		"default_description": ""
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.js",
				"ext": "js",
				"name": "_template",
				"extname": ".js",
				"basename": "_template.js",
				"dirname": "",
				"stem": "_template",
				"path": "_template.js",
				"absolute": "/Users/gary/Code/super-adults/_template.js",
				"isAbsolute": false
			},
			"requirePath": "_template.js",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "form",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "form",
				"stem": "index",
				"path": "form/index.js",
				"absolute": "/Users/gary/Code/super-adults/form/index.js",
				"isAbsolute": false
			},
			"requirePath": "form/index.js",
			"path": "/form/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "form/questions",
				"base": "form.js",
				"ext": "js",
				"name": "form",
				"extname": ".js",
				"basename": "form.js",
				"dirname": "form/questions",
				"stem": "form",
				"path": "form/questions/form.js",
				"absolute": "/Users/gary/Code/super-adults/form/questions/form.js",
				"isAbsolute": false
			},
			"requirePath": "form/questions/form.js",
			"path": "/form/questions/form/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "form/questions",
				"base": "Message.js",
				"ext": "js",
				"name": "Message",
				"extname": ".js",
				"basename": "Message.js",
				"dirname": "form/questions",
				"stem": "Message",
				"path": "form/questions/Message.js",
				"absolute": "/Users/gary/Code/super-adults/form/questions/Message.js",
				"isAbsolute": false
			},
			"requirePath": "form/questions/Message.js",
			"path": "/form/questions/Message/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "form/thank-you",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "form/thank-you",
				"stem": "index",
				"path": "form/thank-you/index.js",
				"absolute": "/Users/gary/Code/super-adults/form/thank-you/index.js",
				"isAbsolute": false
			},
			"requirePath": "form/thank-you/index.js",
			"path": "/form/thank-you/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.js",
				"ext": "js",
				"name": "index",
				"extname": ".js",
				"basename": "index.js",
				"dirname": "",
				"stem": "index",
				"path": "index.js",
				"absolute": "/Users/gary/Code/super-adults/index.js",
				"isAbsolute": false
			},
			"requirePath": "index.js",
			"path": "/",
			"data": {}
		}
	]
}


/*****************
 ** WEBPACK FOOTER
 ** ../config.toml
 ** module id = 389
 ** module chunks = 0
 **/